import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { LightArea } from "./LightArea";
import { LightShadow } from "./LightShadow";
export var Light = /*#__PURE__*/function () {
  function Light() {
    _classCallCheck(this, Light);
    this.area = new LightArea();
    this.shadow = new LightShadow();
  }
  _createClass(Light, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      this.area.load(data.area);
      this.shadow.load(data.shadow);
    }
  }]);
  return Light;
}();